import type {
  EventArgs,
  EventFieldsSetByAPI,
  EventFieldsSetByEventsToolkit,
  EventNameType,
} from "@zapier/avro-events";
import { emit } from "@zapier/events-toolkit-browser";
import { EVENTS_SYSTEM_NAME } from "@zapier/utils";

type RemoveAutoPopulatedEventFields<Type> = {
  [Property in keyof Type as Exclude<
    Property,
    EventFieldsSetByAPI | EventFieldsSetByEventsToolkit
  >]: Type[Property];
};

function sprigTrack(eventName: string) {
  if (globalThis.window === undefined) return;

  const Sprig = (globalThis as { Sprig?: (...args: unknown[]) => void }).Sprig;
  if (!Sprig) return;

  Sprig("track", eventName);
}

const emitEvent = <T extends EventNameType>(
  eventName: T,
  customEventData?: RemoveAutoPopulatedEventFields<EventArgs<T>>,
  systemName?: string,
) => {
  if (
    process.env.NEXT_PUBLIC_VERCEL_ENV === "development" ||
    process.env.VERCEL_ENV === "development"
  ) {
    console.log(
      `⏰ Events-toolkit-browser: would have emitted "${eventName}" event.`,
      {
        ...customEventData,
        system_name: systemName || EVENTS_SYSTEM_NAME,
      },
    );
    return Promise.resolve() as Promise<any>;
  }

  const interactionName =
    (customEventData as { interaction_name?: string })?.interaction_name ??
    eventName;

  sprigTrack(interactionName);

  return emit(
    {
      ...customEventData,
      system_name: systemName || EVENTS_SYSTEM_NAME,
    },
    eventName,
  );
};

export default emitEvent;
